import { SweepEvent } from '../spline/coneSpanner/SweepEvent';
export class PortObstacleEvent extends SweepEvent {
    constructor(site) {
        super();
        this.site = site;
    }
    get Site() {
        return this.site;
    }
}
//# sourceMappingURL=PortObstacleEvent.js.map